import { Component, OnInit,Inject } from '@angular/core';
import { MatDialogRef} from '@angular/material';
import {RestApiService} from '../shared/restApiServices/restapi.service';
import {isUndefined} from "util";
import {MAT_DIALOG_DATA} from '@angular/material';
import { TabsDataService } from "../shared/services/tabs-data.service";
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import 'rxjs/add/operator/filter';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/debounceTime';

@Component({
  selector: 'new-survey-dialog',
  templateUrl: './new-survey-dialog.component.html',
  styleUrls: ['./new-survey-dialog.component.css']
})
export class NewSurveyDialogComponent implements OnInit {

  titleValue:string;
  tagsValue:string;
  category:any;
  priLang:any;
  secondLang:any;
  titleEmpty:string;
  priEmpty:string;
  categoryEmpty:string;
  dialogTitle:string;
  noOfLang:any;
  questions = [];
  owner: string;
  showLoader: boolean;
  showPreview:boolean;
  resData:any = {
    name : '',
    desc : '',
    createdon : '',
    updatedon : '',
    shared :''
  };
  isusetemplate:boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,public newSurveyDialogRef: MatDialogRef<NewSurveyDialogComponent>,private restApiService:RestApiService,private tabsDataService:TabsDataService, private toastyService:ToastyService) {
    this.category = {name:'Other',value:'4'};
    this.priLang = {name:'English',value:'en'};
    this.secondLang = {name:'',value:''};
    this.noOfLang = {name:'Single',value:'Single Language Form'};
    this.showLoader = true;
    this.showPreview = true;    
  }

  ngOnInit() {
    this.setSurveyBasedOnType(this.data);
  }

  getTemplateDetails(){
      this.restApiService.getTemplateDetailsService(this.data).subscribe(
        result => {
          if(result.success!=false)
          {
            this.questions=result.data[0].question;
            this.resData = result.data[0];
            this.owner = result.owner;
            this.showLoader = false;
            this.showPreview = true;
          }
          else {
            console.log("fail"+result.msg);
          }
        });
  }
  deleteTemplate(){
    this.restApiService.deleteTemplates(this.data).subscribe(
      result=>{
        if(result.success!=false)
        {
          this.newSurveyDialogRef.close({success:true});
        }
        else {
          console.log("fail"+result.msg);
        }
      });
  }
  onProceed()
  {
    if(this.isusetemplate)
    {    
      if(this.titleValue==null || this.titleValue=="" || isUndefined(this.titleValue))
      {
        this.titleEmpty = "on-error";
        this.priEmpty = "";
        this.categoryEmpty = "";
      }
      else if(this.category==null || isUndefined(this.category.value)||this.category.value==null||this.category.value=="")
      {
        this.titleEmpty = "";
        this.priEmpty = "";
        this.categoryEmpty = "on-error";
      }
      else if(this.priLang==null ||this.priLang.value==""||this.priLang.value==null||isUndefined(this.priLang))
      {
        this.titleEmpty = "";
        this.categoryEmpty = "";
        this.priEmpty = "on-error";
      }
      else {
        if(this.noOfLang.name =='Multiple')
        {
          this.secondLang = {name:'Hindi',value:'hi'};
        }
        let userInput={
          surveyName:this.titleValue,
          tagsValue:this.tagsValue,
          ctg:this.category.value,
          priLang:this.priLang.value,
          secondLang:this.secondLang.value,
          type: this.data,
          Questionaire_type: 0,
          qnr : this.questions
        };

        let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
        this.restApiService.createQnrService(token,userInput).subscribe(
          result => {
            // console.log(result);
            if(result.success!=false)
            {
              this.tabsDataService.setSurveyTabDataTobeUpdated(true);
              var toastOptions: ToastOptions = {
                title: "Survey Created",
                msg: "Survey was successfully created.",
                showClose: true,
                timeout: 3000,
                theme: 'bootstrap'
              };
              this.toastyService.success(toastOptions);
              result.success = true;
              this.newSurveyDialogRef.close(result.result[0].qID);
            }
            else {
              console.log("fail"+result.msg);
            }

          });
      }
    }
    else{
      this.isusetemplate = true ; 
    }
  }

  cancelCreateTemp(){
    this.isusetemplate = false; 
  }

  onDiscard()
  {
    this.newSurveyDialogRef.close({success:false});
  }

  setLangChoice(lang)
  {
    switch (lang){
      case 'Single':
        this.noOfLang.name = "Single";
        this.noOfLang.value = "Single Language Form";
        break;
      case 'Multiple':
        this.noOfLang.name = "Multiple";
        this.noOfLang.value = "Double Language Form";
        break;
    }
  }

  setPrimaryLang(lang)
  {
    this.priLang = {value:"en",name:"English"};
    switch (lang){
      case 'en':
        this.priLang.value = "en";
        this.priLang.name = "English";
        break;
      case 'hi':
        this.priLang.value = "hi";
        this.priLang.name = "Hindi";
        break;
    }
  }

  setSecondLang(lang)
  {
    this.secondLang = {value:"en",name:"English"};
    switch (lang){
      case 'en':
        this.secondLang.value = "en";
        this.secondLang.name = "English";
        break;
      case 'hi':
        this.secondLang.value = "en";
        this.secondLang.name = "Hindi";
        break;
    }
  }

  setCategory(category)
  {
    this.category = {value:1,name:"Household"};
    switch (category){
      case 1:
        this.category.value = 1;
        this.category.name = "Household";
        break;
      case 2:
        this.category.value = 2;
        this.category.name = "PRI";
        break;
      case 3:
        this.category.value = 3;
        this.category.name = "Anganwadi";
        break;
      case 4:
        this.category.value = 4;
        this.category.name = "Other";
        break;
    }
  }

  setSurveyBasedOnType(type)
  {
      switch (type){
        case 0:
          this.dialogTitle = "New";
          this.showPreview = false;          
          // this.getTemplateDetails();
          break;
        case 1:
          this.dialogTitle = "Household";
          this.setCategory({value:1,name:"Household"});
          this.setPrimaryLang({value:"en",name:"English"});
          this.getTemplateDetails();
          break;
        default:
          this.getTemplateDetails();
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/newSurveyDialog/new-survey-dialog.component.ts